import FootballStatsCategory from "../../../../stats/football-stats-category";
import FootballState from "../../../../state/football-state";
import StatsRule from "../../../../../common/stats-rule";

export default class PassIncompleteStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            (fragment.associatedState === FootballState.PassBrokenUp ||
                fragment.associatedState === FootballState.PassIncomplete ||
                fragment.associatedState === FootballState.PassDropped) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const stats = [];
        this.addStats(
            {
                gameId: play.gameId,
                playId: play.id,
                period: gameContext.currentPeriod,
                teamId: fragment.intendedFor.teamId,
                playerId: fragment.intendedFor.id,
                driveId: gameContext.currentDriveId,
                fragmentId: fragment.id,
                category: FootballStatsCategory.PASS_TARGET,
                values: {
                    attempted: 1
                }
            },
            stats
        );

        if (fragment.brokenUpBy) {
            this.addStats(
                {
                    gameId: play.gameId,
                    playId: play.id,
                    period: gameContext.currentPeriod,
                    teamId: fragment.brokenUpBy.teamId,
                    playerId: fragment.brokenUpBy.id,
                    driveId: gameContext.currentDriveId,
                    fragmentId: fragment.id,
                    category: FootballStatsCategory.PASS_BROKEN_UP,
                    values: {
                        completed: 1
                    }
                },
                stats
            );
        }

        return stats;
    }
}
